import { ReactNode, useEffect } from 'react';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import s from './styles.scss';
import { enums } from 'edrolo-ui';

export interface PopoverProps {
  children: ReactNode;
  isOpen: boolean;
  anchor: HTMLElement | null;
  placement?: enums.Placement;
  closePopover: () => void;
}

export const Popover = ({
  children,
  isOpen,
  anchor,
  placement = enums.Placement.BOTTOM,
  closePopover, // closePopover is required to close with escape key
}: PopoverProps) => {
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        closePopover();
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    } else {
      return undefined; // Return undefined explicitly if isOpen is false
    }
  }, [isOpen, closePopover]);
  return (
    <BasePopup
      open={isOpen}
      anchor={anchor}
      placement={placement}
      offset={8}
      style={{ zIndex: 10 }}
      tabIndex={0}
    >
      <div className={s.popover}>{children}</div>
    </BasePopup>
  );
};
